import { Box, ButtonGroup, IconButton, Tooltip, Zoom } from "@material-ui/core";
import * as React from "react";
import { FindInPage } from "@material-ui/icons";
import { WaitingResponseType } from "../../../../../Enums/WaitingResponseType";
import { useAuth } from "@airborne/react-admin";
import CancelIcon from "@material-ui/icons/Cancel";
import TimelineIcon from "@material-ui/icons/Timeline";
import EditIcon from "@material-ui/icons/Edit";
import ReplayIcon from "@material-ui/icons/Replay";
import { PbhRequestStatus } from "../../../../../Enums/PbhRequestStatus";
export const Actions = ({
  mainData,
  cancelButtonClick,
  sendAgainButtonClick,
  commentHistoryOnClick,
  editButtonClick,
  ...props
}) => {
  const { user } = useAuth();
  const unChangeableStatus = [PbhRequestStatus.Accomplished, PbhRequestStatus.Rejected, PbhRequestStatus.Cancelled];

  const isUnChangeable = (): boolean => {
    return unChangeableStatus.includes(mainData?.requestStatus);
  };

  return (
    <Box style={{ flex: 1, flexDirection: "row" }}>
      <ButtonGroup variant="text" size="small">
        {/* <RemarkButton record={record} /> */}
        {user?.isCustomer === false &&
          isUnChangeable() === false &&
          mainData?.requestStatus !== PbhRequestStatus.Cancelled && (
            <SendAgainButton sendAgainButtonClick={sendAgainButtonClick} record={props?.record} />
          )}
        {user?.isCustomer === false &&
          isUnChangeable() === false &&
          mainData?.requestStatus !== PbhRequestStatus.Cancelled && (
            <CancelButton cancelButtonClick={cancelButtonClick} record={props?.record} />
          )}
        {isUnChangeable() === false && mainData?.requestStatus !== PbhRequestStatus.Cancelled && (
          <EditButton editButtonClick={editButtonClick} record={props?.record} />
        )}
        <FileDetailButton fileDetailOnClick={props.fileDetailOnClick} record={props?.record} />
        <CommentHistoryButton commentHistoryOnClick={commentHistoryOnClick} record={props?.record} />
      </ButtonGroup>
    </Box>
  );
};
export default Actions;

const FileDetailButton = ({ record, fileDetailOnClick }) => {
  return (
    <IconButton color="primary" onClick={() => fileDetailOnClick(record)}>
      <Tooltip TransitionComponent={Zoom} title="File Detail">
        <FindInPage />
      </Tooltip>
    </IconButton>
  );
};

const CommentHistoryButton = ({ record, commentHistoryOnClick }) => {
  return (
    <IconButton color="primary" onClick={() => commentHistoryOnClick(record)}>
      <Tooltip TransitionComponent={Zoom} title="Comment History">
        <TimelineIcon />
      </Tooltip>
    </IconButton>
  );
};

const EditButton = ({ record, editButtonClick }) => {
  return (
    <IconButton
      color="primary"
      onClick={() => editButtonClick(record)}
      disabled={record?.waitingResponseEnum === WaitingResponseType.Cancelled}
    >
      <Tooltip TransitionComponent={Zoom} title="Comment Edit">
        <EditIcon />
      </Tooltip>
    </IconButton>
  );
};

const CancelButton = ({ record, cancelButtonClick }) => {
  return (
    <IconButton
      onClick={() => cancelButtonClick(record)}
      color="primary"
      disabled={record?.waitingResponseEnum === WaitingResponseType.Cancelled}
    >
      <Tooltip TransitionComponent={Zoom} title="Cancel">
        <CancelIcon />
      </Tooltip>
    </IconButton>
  );
};

const SendAgainButton = ({ record, sendAgainButtonClick }) => {
  return (
    <IconButton
      onClick={() => sendAgainButtonClick?.(record)}
      color="primary"
      disabled={
        record?.waitingResponseEnum === WaitingResponseType.WaitingResponseFromCustomer ||
        record?.waitingResponseEnum === WaitingResponseType.Cancelled
      }
    >
      <Tooltip TransitionComponent={Zoom} title="Send Again">
        <ReplayIcon />
      </Tooltip>
    </IconButton>
  );
};
